import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "812px",
  },
  form: {
    marginTop: theme.spacing(6),
  },
  formTitle: {
    marginTop: theme.spacing(3),
  },
  input: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttonWrapper: {
    marginTop: theme.spacing(4),
  },
}));

export default useStyles;
